import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'

List.Item = ListItem
List.ItemButton = ListItemButton
List.ItemIcon = ListItemIcon
List.ItemText = ListItemText
List.Subheader = ListSubheader
export default List
